import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "globalSlice",
  initialState: {
    entities: [],
    getByIdUsers: {},
    loading: false,
    error: null,
    total: 0,
    sideBarVisible: false
  },
  reducers: {
    setSideBarVisible: (state, payload) => {
        state.sideBarVisible = payload.payload
    }
  },
  extraReducers: (builder) => {
  }
});
export const { setSideBarVisible } = globalSlice.actions;

export default globalSlice.reducer;
